import '.b2{position:relative;}.ssr-plugin'
import '.iq{display:inline-block;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.gx{padding:0.25rem 1rem;}.ssr-plugin'
import '.js{border-radius:1.875rem;}.ssr-plugin'
import '.jt{border:2px solid var(--brand-secondary);}.ssr-plugin'
import '.d7{background:var(--palette-white);}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.gq{padding:0.75rem 1.25rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import Column from '@app/components/layout/Column'
import { Text } from '../typography/Text'
import useClickOutside from '@app/util/hooks/useClickOutside'

export type SortOption = {
  value: string
  label: string
}

export type SortingDropdownProps = {
  options: SortOption[]
  selectedValue: string
  onSelect: (value: string) => void
}

export const SortingDropdown = ({
  options,
  selectedValue,
  onSelect,
}: SortingDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const selectedOption = options.find((opt) => opt.value === selectedValue)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const handleSelect = (value: string) => {
    onSelect(value)
    setIsOpen(false)
  }

  return (
    <div className="b2 iq"
      ref={dropdownRef}
    >
      <styled.button className="a r s gx js jt d7 a3 z"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          '&:hover': {
            background: 'var(--gray-50)',
          },
        }}
      >
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            fontWeight: 600,
            fontSize: '1rem',
          }}
        >
          {selectedOption?.label}
        </Text.Medium>
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            color: 'var(--brand-secondary)',
            fontSize: '0.875rem',
          }}
        />
      </styled.button>

      {isOpen && (
        <Column
          alignItems="stretch"
          style={{
            position: 'absolute',
            top: 'calc(100% + 0.5rem)',
            left: 0,
            minWidth: '100%',
            backgroundColor: 'var(--palette-white)',
            borderRadius: '0.75rem',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 1000,
            overflow: 'hidden',
          }}
        >
          {options.map((option) => (
            <styled.div className="gq z"
              key={option.value}
              onClick={() => handleSelect(option.value)}
              style={{
                backgroundColor:
                  option.value === selectedValue
                    ? 'var(--gray-100)'
                    : 'var(--palette-white)',
                '&:hover': {
                  backgroundColor: 'var(--gray-100)',
                },
              }}
            >
              <Text.Medium
                style={{
                  color: 'var(--brand-secondary)',
                  fontSize: '1rem',
                }}
              >
                {option.label}
              </Text.Medium>
            </styled.div>
          ))}
        </Column>
      )}
    </div>
  )
}
